import Vue from 'vue';
import optimusApi from '../optimus/api';

const GET_STATS_REQUEST = 'GET_STATS_REQUEST',
    GET_STATS_SUCCESS = 'GET_STATS_SUCCESS',
    GET_STATS_ERROR = 'GET_STATS_ERROR';

const state = {
    stats: {},
    statsStatus: {},
};

const getters = {
	stats: state => state.stats,
	credits: state => (state.stats && state.stats.credits) || {},
    statsStatus: state => state.statsStatus,
};

const actions = {
	[GET_STATS_REQUEST]: ({ commit, dispatch, rootGetters }, payload) => {
        commit(GET_STATS_REQUEST);
		optimusApi.getStats(payload)
			.then(response => {
				commit(GET_STATS_SUCCESS, response.stats);
			})
			.catch(error => {
				commit(GET_STATS_ERROR);
            });
    },
};

const mutations = {
	[GET_STATS_REQUEST]: (state) => {
        state.stats = {};
		state.statsStatus = {
			loading: true
        };
	},
	[GET_STATS_SUCCESS]: (state, stats) => {
		state.statsStatus = {
			success: true
        };
        state.stats = stats;
	},
	[GET_STATS_ERROR]: (state) => {
		state.statsStatus = {
			error: true
		};
    },
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/modules/stats/store.js